import { IMatomoGlobal } from "../interfaces/IMatomoGlobal";

export const matomoGlobal: IMatomoGlobal = window as unknown as IMatomoGlobal;
